import { useProjectConfig, useUpdateProjectConfig } from './useProjectConfig.js';

export interface ScopeStatementData {
  scope_statement: string;
}

export interface UseScopeStatementResult {
  data: ScopeStatementData | undefined;
  isLoading: boolean;
  save: (value: string) => Promise<void>;
  isSaving: boolean;
}

/**
 * Dünner Wrapper über useProjectConfig/useUpdateProjectConfig.
 *
 * Hintergrund:
 *   `scope_statement` ist ein Feld der project_config (PM-API v0.4.0).
 *   GET  /api/v1/projects/:id/config       -> liefert config inkl. scope_statement
 *   PATCH /api/v1/projects/:id/config      -> Upsert eines Teil-Patches (nur scope_statement)
 *
 * Externe Signatur unverändert: { data, isLoading, save, isSaving }.
 */
export function useScopeStatement(projectId: string | undefined): UseScopeStatementResult {
  const cfg = useProjectConfig(projectId);
  const update = useUpdateProjectConfig(projectId ?? '');

  // apiClient.get returnt die Response im Shape { data: <payload> } — analog zu
  // ProjectConfigTab/ProjektauftragTab, die ebenfalls (data as { data?: T }).data lesen.
  const config = (cfg.data as unknown as { data?: { scope_statement?: string } } | undefined)?.data ?? null;
  const scope = config?.scope_statement ?? '';

  return {
    data: config ? { scope_statement: scope } : undefined,
    isLoading: cfg.isLoading,
    save: async (value: string) => {
      await update.mutateAsync({ scope_statement: value });
    },
    isSaving: update.isPending,
  };
}
